import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-sign-history',
  templateUrl: './sign-history.component.html',
  styleUrl: './sign-history.component.scss'
})
export class SignHistoryComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() dataId!: string ;
  @Output() close : EventEmitter<boolean> = new EventEmitter<boolean>()
  signHistory: any;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataId'] && changes['dataId'].currentValue) {
      this.fetchSignHistory();
    }
  }

  async fetchSignHistory() {
    if (!this.dataId) return

    try {

      let res = await this.dataService.getData('data/sign-hostory/'+this.dataId)

      if(res.error) return

      this.signHistory = res.data
      
    } catch (error) {
      console.log(error)
    }

  }

  hide(){
    this.close.emit(false)
  }

}
